export default __webpack_public_path__ + "static/media/view_disabled.5015af06.svg";